module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./~/htmlparser2/lib/entities/xml.json
// module id = 665
// module chunks = 168707334958949